import React from 'react'
import { Link } from 'react-router-dom'
import { Parallax } from 'react-scroll-parallax';

const RadiothonBanner = () => (
  <div style={{ backgroundColor: 'black' }}>

  <div className="main-banner" style={{ position: 'relative', width: '100%', height: '155vw', overflow: 'hidden'}}>

      <div className='radiothon-art' style={{background: 'url(/assets/stars.png) top center no-repeat, transparent', width: 'calc(100vw - (100vw - 100%))', height: '100vw', backgroundPosition: 'top center', backgroundSize: 'contain', position: 'absolute', top: '0', left: 0 }}>
      </div>


      <div style={{ position: 'absolute', top: 0, left: 0, height: '130vw', width: '100vw', maxWidth: '100%', overflow: 'hidden'}}>
        <div className="radiating-circle ripple-one"></div>
        <div className="radiating-circle ripple-two"></div>
        <div className="radiating-circle ripple-three"></div>
        <div className="radiating-circle ripple-four"></div>
      </div>

   
      <div style={{position: 'absolute', left: '30vw', top: '10vw', }} >
      <Parallax translateY={[-40, 40]} translateX={[60, -60]}>
        <div className='radiothon-announcer' style={{background: 'url(/assets/cloud1.png) left top no-repeat, transparent', width: '15vw', height: '15vw', backgroundPosition: 'left top', backgroundSize: 'contain' }}>
        </div>
      </Parallax>
      </div>

      <div style={{position: 'absolute', left: '50vw', top: '30vw', }} >
      <Parallax translateY={[-40, 40]} translateX={[40, -60]}>
        <div className='radiothon-announcer' style={{background: 'url(/assets/cloud2.png) left top no-repeat, transparent', width: '15vw', height: '15vw', backgroundPosition: 'left top', backgroundSize: 'contain' }}>
        </div>
      </Parallax>
      </div>


      <div style={{position: 'absolute', left: '85vw', top: '20vw', }} >
      <Parallax translateY={[-40, 40]} translateX={[70, -70]}>
        <div className='radiothon-announcer' style={{background: 'url(/assets/cloud4.png) left top no-repeat, transparent', width: '15vw', height: '15vw', backgroundPosition: 'left top', backgroundSize: 'contain' }}>
        </div>
      </Parallax>
      </div>

      <div style={{position: 'absolute', left: '5vw', top: '60vw', }} >
      <Parallax translateY={[-40, 40]} translateX={[70, -70]}>
        <div className='radiothon-announcer' style={{background: 'url(/assets/cloud5.png) left top no-repeat, transparent', width: '15vw', height: '15vw', backgroundPosition: 'left top', backgroundSize: 'contain' }}>
        </div>
      </Parallax>
      </div>

      <div className='radiothon-art' style={{background: 'url(/assets/background-hills.png) center center no-repeat, transparent', width: 'calc(100vw - (100vw - 100%))', height: '145vw', backgroundPosition: 'center', backgroundSize: 'contain', position: 'absolute', top: '25vw', left: 0 }}>
      </div>

      <div className='radiothon-art' style={{background: 'url(/assets/tower.png) center center no-repeat, transparent', width: '10vw', height: '20vw', backgroundPosition: 'center', backgroundSize: 'contain', position: 'absolute', top: '38.5vw', left: '49vw'}}>
      </div>

      <div style={{position: 'absolute', left: '55vw', top: '47vw', }} >
      <Parallax translateY={[-40, 40]} translateX={[70, -70]}>
        <div className='radiothon-announcer' style={{background: 'url(/assets/cloud3.png) left top no-repeat, transparent', width: '15vw', height: '15vw', backgroundPosition: 'left top', backgroundSize: 'contain' }}>
        </div>
      </Parallax>
      </div>


      <div style={{position: 'absolute', left: '35vw', top: '120vw', }} >
      <Parallax translateY={[-40, 40]} translateX={[70, -70]}>
        <div className='radiothon-announcer' style={{background: 'url(/assets/cloud6.png) left top no-repeat, transparent', width: '15vw', height: '15vw', backgroundPosition: 'left top', backgroundSize: 'contain' }}>
        </div>
      </Parallax>
      </div>

      <div style={{position: 'absolute', left: '80vw', top: '110vw', }} >
      <Parallax translateY={[-40, 40]} translateX={[70, -70]}>
        <div className='radiothon-announcer' style={{background: 'url(/assets/cloud7.png) left top no-repeat, transparent', width: '15vw', height: '15vw', backgroundPosition: 'left top', backgroundSize: 'contain' }}>
        </div>
      </Parallax>
      </div>


      <div style={{position: 'absolute', left: '60vw', top: '70vw', }} >
      <Parallax translateY={[-40, 40]} translateX={[70, -70]}>
        <div className='radiothon-announcer' style={{background: 'url(/assets/cloud8.png) left top no-repeat, transparent', width: '15vw', height: '15vw', backgroundPosition: 'left top', backgroundSize: 'contain' }}>
        </div>
      </Parallax>
      </div>

      <div style={{position: 'absolute', left: '0vw', top: '92vw'}} >
        <Parallax translateY={[5, -5]}>
          <div className='radiothon-cast' style={{background: 'url(/assets/foreground-hills.png) center center no-repeat, transparent', width: '100vw', height: '100vw', backgroundPosition: 'center', backgroundSize: 'contain' }}>
          </div>

        </Parallax>

      </div>


      <div style={{position: 'absolute', left: '0vw', top: '-10vw', }} >
      <Parallax translateY={[-30, 40]}>
        <div style={{background: 'url(/assets/tree-bats.png) center center no-repeat, transparent', width: '100vw', height: '100vw', backgroundPosition: 'right', backgroundSize: '50vw' }}>
        </div>
      </Parallax>
      </div>

      <div style={{position: 'absolute', left: '0vw', top: '-10vw', }} >
      <Parallax translateY={[-20, 30]}>
        <div className='radiothon-announcer' style={{background: 'url(/assets/tree-owl-snake.png) left top no-repeat, transparent', width: '100vw', height: '150vw', backgroundPosition: 'left top', backgroundSize: '100vw' }}>
        </div>
      </Parallax>
      </div>

      <div style={{position: 'absolute', left: '0vw', top: '105vw', }} >
      <Parallax translateY={[-20, -10]}>
        <div style={{background: 'url(/assets/lizard.png) center center no-repeat, transparent', width: '100vw', height: '100vw', backgroundPosition: 'right', backgroundSize: '50vw' }}>
        </div>
        <div style={{position: 'absolute', right: '-2vw', top: '47vw', fontSize: 12, color: 'black', transform: 'rotate(-90deg)'}}>Art by <a style={{color: 'black'}} href="https://www.instagram.com/georgelevi___">George Levi</a></div>
      </Parallax>
      </div>

      <div style={{position: 'absolute', left: '-2vw', top: '95vw', }} >
      <Parallax translateY={[-20, -10]}>
        <div className='radiothon-announcer' style={{background: 'url(/assets/curlew.png) center center no-repeat, transparent', width: '100vw', height: '100vw', backgroundPosition: 'left', backgroundSize: '46vw' }}>
        </div>
      </Parallax>
      </div>


      <div style={{position: 'absolute', left: '13vw', top: '58vw'}} >
        <Parallax translateY={[-40, 10]}>
          <div className='radiothon-text' style={{background: 'url(/assets/adventurous-ears.png) center center no-repeat, transparent', width: '75vw', height: '100vw', backgroundPosition: 'center', backgroundSize: 'contain' }}>
          </div>

        </Parallax>
      </div>

      {/* <div style={{position: 'absolute', left: '37.5vw', top: '102vw'}} >
        <Parallax translateY={[0, -20]}>
          <div className='radiothon-text' style={{background: 'url(/assets/dates.png) center center no-repeat, transparent', width: '25vw', height: '100vw', backgroundPosition: 'center', backgroundSize: 'contain' }}>
          </div>

        </Parallax>
      </div> */}
 

    </div>

    <div class="main-para">

    <p>Every day is an adventure at 4ZZZ and <span style={{textDecoration: 'underline'}}>we’d like to thank all the trailblazers who’ve joined us this Radiothon</span>, where we’ve been celebrating your Adventurous Ears.</p>

    <p>Don’t worry if you’re late to the party, there’s still time to subscribe. We’ve kept a few choice prizes available to help seal the deal; a year of fresh produce from <span style={{textDecoration: 'underline'}}>All My Friends</span>, a year of beer from <span style={{textDecoration: 'underline'}}>Young Henrys</span> and a <span style={{textDecoration: 'underline'}}>Triffid</span> Golden Ticket for you and a friend.
    </p>

    </div>
  </div>
)

export default RadiothonBanner
